import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Text } from '@frontend/design-system';

type Props = {
  title: string;
  children?: ReactNode;
};

export const QuickFilterPopoverMenuGroup = ({ title, children }: Props) => {
  return (
    <div css={sectionContainerStyles}>
      <div css={headerContainerStyles}>
        <Text weight='bold'>{title}</Text>
      </div>
      {children}
    </div>
  );
};

const sectionContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--fabric-space-gap-sm)',
  padding: '0 var(--fabric-space-gap-md)',
});

const headerContainerStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'var(--fabric-space-gap-md)',
});
